import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router'

import { useAuth } from '@ui/providers/AuthProvider'

export function RequireUser({ children }: { children: JSX.Element }) {
  const auth = useAuth()
  const location = useLocation()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    auth.restoreSession(() => {
      setLoading(false)
    })
  }, [auth])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!auth || !auth.currentMember) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}
